import React from 'react'
import classNames from 'classnames'
import MobileMenuFooter from './MobileMenuFooter'
import MobileMenuHeader from './MobileMenuHeader'
import MobileParentMenuLink from './MobileParentMenuLink'
import MobileSubMenu from './MobileSubMenu'
import useWindowSize from '@toasttab/shared/src/hooks/useWindowSize'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useNavContext } from '../useNavContext'
import { MobileTabbedMenuProps } from '../ContentfulNavigation.d'

const MobileTabbedMenu = ({
  handleCloseButton,
  menu,
  menuCss
}: MobileTabbedMenuProps) => {
  const { headerHeight } = usePageContext()
  const { selectedTabbedMenu, setSelectedParentMenu, setSelectedTabbedMenu } =
    useNavContext()

  const windowSize = useWindowSize()
  const isDesktopLayout = windowSize.width >= 1024

  const isOpen = selectedTabbedMenu === menu.title
  const menuClasses = classNames(
    menuCss,
    'z-[101] flex flex-col overflow-y-auto no-scrollbar',
    {
      'right-[-800px] md:left-[-500px]': !isOpen || isDesktopLayout,
      'right-0 md:left-0': isOpen && !isDesktopLayout
    }
  )

  const handleBackButton = () => {
    setSelectedParentMenu(null)
    setSelectedTabbedMenu(null)
  }

  const tabLinks: string[] = []
  const tabContent: any[] = []
  menu.dropdownContent?.tabbedContent?.forEach((tab: any) => {
    tabLinks.push(tab.title)
    tabContent.push({ ...tab })
  })

  return (
    <>
      <nav
        aria-hidden={!isOpen}
        aria-label={`Toast ${menu.title} Dropdown Menu`}
        className={menuClasses}
        data-testid='MobileTabbedMenu'
        id={`mobile-tabbed-menu-${menu.title.replace(/ /g, '-').toLowerCase()}`}
        tabIndex={!isOpen || isDesktopLayout ? -1 : 0}
        style={{
          height:
            windowSize.width >= 768
              ? `calc(100dvh - ${headerHeight}px)`
              : '100dvh',
          paddingBottom: 'env(safe-area-inset-bottom)',
          top: windowSize.width >= 768 ? `${headerHeight}px` : '0'
        }}
      >
        <MobileMenuHeader
          handleBackButton={handleBackButton}
          handleCloseButton={handleCloseButton}
          showOnTablet
          title={menu.title}
        />
        {tabLinks.map((link: string) => (
          <MobileParentMenuLink isMenu key={link} title={link} />
        ))}
        {menu.dropdownContent?.sectionLink ? (
          <a
            className='block p-4 text-[22px] text-default font-normal flex items-center border-b border-light'
            href={menu.dropdownContent.sectionLink.url}
          >
            <span className='before:content-icon-all-products before:block before:leading-none pt-0.5 bg-neutral rounded-full flex items-center justify-center w-8 h-8 mr-2' />
            {menu.dropdownContent.sectionLink.title}
          </a>
        ) : null}
        <div className='mt-auto px-4 flex-shrink-0 pb-4'>
          <MobileMenuFooter dataTestId='MobileTabbedMenu-menuFooter' />
        </div>
      </nav>
      {tabContent.map((content: any) => (
        <MobileSubMenu
          {...content}
          handleCloseButton={handleCloseButton}
          key={`${menu.title}-${content.title}`}
          showcaseEntries={menu.dropdownContent.showcaseEntries}
          subMenus={{
            columns: [
              [
                {
                  subMenuEntries: content.subMenuEntries,
                  subMenuEntryType: 'links'
                }
              ]
            ]
          }}
        />
      ))}
    </>
  )
}

export default MobileTabbedMenu
